<template>
  <b-row class="my-4">
    <b-col cols="12">
      <div class="w-100 h-100 d-flex flex-row flex-grow-1 mode-container py-3 px-3">
        <div class="mode-col px-2 py-1"> {{ mode.titre}}</div>
        <div class="mode-col px-2 py-1"> {{`${mode.min_delai} - ${mode.max_delai} jours`}}</div>
        <div class="mode-col px-2 py-1"> {{ mode.frais | in_euro}}</div>
        <div :class="{'desactive': !mode.active }" class="mode-col px-2 py-1">
          <div class="w-100 h-100 d-flex flex-row justify-content-between align-content-between">
            <p class="m-0">{{mode.active ? 'Activé': 'Desactivé'}}</p>
            <span v-if="!hideOption" >
            <a :id="'popover-target-' + mode.livraison_mode_id" style="text-decoration: none" tabindex="0" class="sub-cat-options">
              <b-icon   font-scale="1.5" class="three-dots-icon  pointer" icon="three-dots-vertical"></b-icon>
            </a>
            <b-popover  :target="'popover-target-' + mode.livraison_mode_id" triggers="focus" placement="bottom">
              <b-list-group>
                <b-list-group-item v-b-modal.sub-categorie-update button @click="updateMode" class="d-flex justify-content-between align-items-center pointer">
                  <p class="m-0 mr-2">Editer</p>
                  <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
                </b-list-group-item>
                <b-list-group-item @click="deleteMode" button v-b-modal.confirm-modal class="d-flex justify-content-between align-items-center pointer">
                  <p class="m-0 mr-2">Supprimer</p>
                  <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                </b-list-group-item>
              </b-list-group>
            </b-popover>
            </span>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {removeReference} from "@/helpers";

export default {
  name: "livraison-mode",
  props:['mode', 'hideOption'],
  methods:{
    updateMode(){

      this.$emit('update', this.mode);
    },
    deleteMode(){
      this.$emit('delete', {id: this.mode.livraison_mode_id});
    }
  }
}
</script>

<style scoped>
.mode-col{
  flex: 1 1 0px;
}
.mode-col:not(:last-child){
  border-right: 2px solid #f3e0c5 ;
}
.mode-container{
  border: 1px solid #edcea5;
  border-radius: 8px;
  box-shadow: 0px 3px 9px #80808057;
}
.desactive{
  color:#d85757 ;
}
.three-dots-icon{
  color: #e3e3e3;
}

/deep/ .popover-body{
  padding: 0;
}
</style>
